module.exports = __webpack_public_path__ + "img/search.e7c97515.svg";